import { render, staticRenderFns } from "./SiteIcon.vue?vue&type=template&id=72f001f5&scoped=true"
import script from "./SiteIcon.vue?vue&type=script&lang=js"
export * from "./SiteIcon.vue?vue&type=script&lang=js"
import style0 from "./SiteIcon.vue?vue&type=style&index=0&id=72f001f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f001f5",
  null
  
)

export default component.exports